import { Component, signal } from '@angular/core';
import { SetupWizardClientForm } from '../../../../../forms/setup-wizard/setup-wizard-client-form/setup-wizard-client-form';
import { Client, SetupWizardClientFormPayload } from '@mira-avant/mtlibs';
import { SetupWizard } from '../../../../../../services/setup-wizard';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ClientService } from '../../../../../../services/client.service';
import { consoleLoggingIntegration } from '@sentry/angular';
import { SetupWizardUploadCsvButton } from '../../setup-wizard-upload-csv-button/setup-wizard-upload-csv-button';

@Component({
	selector: 'app-setup-wizard-client-editor',
	imports: [SetupWizardClientForm, SetupWizardUploadCsvButton],
	standalone: true,
	templateUrl: './setup-wizard-client-editor.html',
	styleUrl: './setup-wizard-client-editor.scss',
})
export class SetupWizardClientEditor {
	public loading = signal<boolean>(false);
	private clientUuid: string | undefined;
	private sub?: Subscription;
	private clientSub?: Subscription;
	public client = signal<Client | null>(null);

	constructor(
		private route: ActivatedRoute,
		private setupWizard: SetupWizard,
		private clientService: ClientService
	) {
		this.sub = this.route.params.subscribe(async params => {
			this.clientUuid = params['clientUuid'];

			if (!this.clientUuid) {
				throw new Error('Client UUID is not defined');
			}

			this.clientSub?.unsubscribe();

			this.clientSub = this.clientService.selectedClientBs$.subscribe(client => {
				if (!client) {
					return;
				}

				const currentClient = this.client();

				//Just set value upon first load for now
				if (!currentClient) {
					this.client.set(client);
				}
			});

			await this.clientService.selectClient$(this.clientUuid);
		});
	}

	public onFormSubmit(payload: SetupWizardClientFormPayload) {
		if (!this.clientUuid) {
			throw new Error('Client UUID is not defined');
		}

		console.log('Form submitted in editor:', payload);

		this.loading.set(true);

		this.setupWizard
			.updateClient$(this.clientUuid, payload)
			.then(result => {
				console.log('Client update result:', result);
			})
			.catch(error => {
				console.error('Error updating client:', error);
			})
			.finally(() => {
				this.loading.set(false);
			});
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
		this.clientSub?.unsubscribe();
	}
}
